// src/components/Footer.js
import React from "react";
import "../styles/App.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>© 2025 Client Tour Management. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
